<template>
  <div class="productCertificate-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('finance.name39')" prop="tenantId">
              <el-cascader ref="refHandle" v-model="tenantIds"  :show-all-levels="false" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions, checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('bike.name294')" prop="ebikeId">
            <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name295')" prop="ebikeCode">
            <el-input v-model="queryInfo.ebikeCode" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
           <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
            <el-input v-model="queryInfo.ebikeModelId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name368')" prop="saleStatus" >
          <el-select v-model="queryInfo.saleStatus" :placeholder="$t('public.name1')" style="width:100%" clearable>
    <el-option
      v-for="item in saleStatusOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item>
          <el-form-item :label="$t('bike.name367')" prop="searchTime">
              <el-date-picker
            v-model="queryInfo.searchTime"
            type="daterange"
           value-format="yyyy-MM-dd"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
          </el-form-item>
          <el-form-item >
          <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
          <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div>
      <!-- <el-button type="primary" size="medium" @click="getPageList">{{ $t('manage.name60') }}</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="importProductDialog">导入产品质量合格证</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showAddIotNum">{{ $t('bike.name156') }}</el-button> -->
      <el-button type="primary" size="medium" @click="importBikeFactoryDialog" v-if="buttonPerms.indexOf('zBike/importVehicleFactoryInformation') > -1">{{ $t('bike.name400') }}</el-button>
      <el-button type="primary" size="medium" @click="importEditEbikeInfo" v-if="buttonPerms.indexOf('bike/importEditEbikeInfo') > -1">{{ $t('bike.name402') }}</el-button>
      <el-button type="primary" size="medium" @click="exportVehicle" :loading="loadingVehicle">{{ $t('bike.name529') }}</el-button>
      <el-button type="primary" size="medium" @click="exportCcc" :loading="loading">{{ $t('bike.name369') }}</el-button>
    </div>
    <el-table ref="table" :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='tableLoading' @selection-change="onSelectTab">
      <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
      <el-table-column :label="$t('finance.name40')" prop="tenantName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable></el-table-column>
      <el-table-column :label="$t('bike.name272')" prop="ebikeId" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name273')" prop="productName" sortable width="180px"></el-table-column> -->
      <el-table-column :label="$t('bike.name274')" prop="ebikeModelId" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name275')" prop="manufacturerTrademark" sortable width="220px"></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name276')" prop="manufacturingPlantAddress" sortable width="240px"></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name277')" prop="manufactureDate" sortable width="280px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name279')" prop="motorCode" sortable width="180px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name280')" prop="driveType" sortable width="150px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name281')" prop="maxSpeed" sortable width="200px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name282')" prop="ebikeQuality" sortable width="140px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name283')" prop="powerVoltage" sortable width="280px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name284')" prop="batteryType" sortable width="140px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name285')" prop="lengthWidthHeight" sortable width="280px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name286')" prop="beforeAfterWheelDistance" sortable width="360px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name287')" prop="nameplateFixPosition" sortable width="220px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name288')" prop="ebikeCodePosition" sortable width="200px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name289')" prop="serviceLife" sortable width="200px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name290')" prop="materialFlowLeaseManage" sortable width="370px" ></el-table-column> -->
      <el-table-column :label="$t('bike.name291')" prop="cccCode" sortable width="280px" ></el-table-column>
      <!-- <el-table-column :label="$t('bike.name292')" prop="engraveEbikeCode" sortable width="180px" ></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name293')" prop="certificateConformityUrl" sortable>
        <template slot-scope="scope">
          <el-image v-if="scope.row.certificateConformityUrl"  style="width: 40px; height: 40px" :src="scope.row.certificateConformityUrl" :preview-src-list="[scope.row.certificateConformityUrl]"></el-image>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="外观形状的左前方45°" prop="faultTime" width="100px" ></el-table-column>
      <el-table-column label="外观形状的右后方45°" prop="faultTime" width="100px" ></el-table-column>
      <el-table-column label="正面照片" prop="faultTime" width="120px" ></el-table-column>
      <el-table-column label="车头朝左侧面照片" prop="faultTime" width="110px" ></el-table-column> -->
      <el-table-column :label="$t('bike.name367')" prop="manufactureDate"></el-table-column>
      <el-table-column :label="$t('bike.name310')" prop="saleStatus" sortable>
        <template slot-scope="scope">
         {{ [$t('bike.name312'), $t('bike.name311')][scope.row.saleStatus] }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name11')" width="300px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)">{{ $t('bike.name46') }}</el-button>
          <el-button type="text" @click="showIotDetailsDialog(scope.row)">IOT</el-button>
          <!-- <el-button type="text" @click="showCertificateDialog(scope.row)">{{ $t('bike.name214') }}</el-button> -->
          <el-button type="text" @click="showSalesRecord(scope.row)" v-if="scope.row.saleStatus === '1'">{{ $t('tabmenu.name69') }}</el-button>
          <el-button type="text" @click="showMaintenanceRecord(scope.row)">{{ $t('tabmenu.name68') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <el-dialog
  :title="$t('tabmenu.name68')"
  :visible.sync="dialogVisible"
  width="80%"
  v-if="dialogVisible"
  :before-close="handleClose">
  <el-table :data="maintenanceRecordTableList" :span-method="objectSpanMethod" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1">
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name450')" prop="id" sortable width="200"> </el-table-column>
      <el-table-column :label="$t('bike.name451')" prop="userName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name452')" prop="storeAddress" sortable></el-table-column>
      <el-table-column :label="$t('bike.name453')" prop="createTime" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name454')" prop="maintainTypeName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name455')" prop="oldPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name456')" prop="newPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name457')" prop="filePathList" sortable>
        <template slot-scope="scope" v-if="scope.row.filePathList.length > 0">
          <el-image style="width: 50px; height: 50px" :src="scope.row.filePathList[0]" :preview-src-list="scope.row.filePathList"></el-image>
        </template>
      </el-table-column>
    </el-table>
</el-dialog>
<el-dialog
  :title="$t('tabmenu.name69')"
  :visible.sync="dialogVisible2"
  v-if="dialogVisible2"
  width="80%"
  :before-close="handleClose">
  <el-table :data="salesRecordTableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1">
    <el-table-column :label="$t('bike.name29')" prop="createTime" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name452')" prop="storeAddress" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name451')" prop="userName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name458')" prop="saleDate" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name459')" prop="invoicePath" sortable>
        <template slot-scope="scope" v-if="scope.row.invoicePath">
          <el-image style="width: 50px; height: 50px" :src="scope.row.invoicePath" :preview-src-list="[scope.row.invoicePath]"></el-image>
        </template>
      </el-table-column>
    </el-table>
</el-dialog>
 <!--车辆详情-->
<el-dialog :title="$t('bike.name161')" :visible.sync="eBikeDetailsDialog" v-if="eBikeDetailsDialog" :before-close="closeEBikeDialog" width="1440px">
      <EBikeDetailsDialog ref="eBikeDetailsDialog" :e-bike-id="eBikeBaseInfo.ebikeId" :e-bike-code="eBikeBaseInfo.ebikeCode" :type="type"></EBikeDetailsDialog>
    </el-dialog>
      <!--合格证-->
      <el-dialog :visible.sync="certificateDialog" v-if="certificateDialog" :close-on-click-modal ="false" :before-close="closeCertificateDialog" width="1440px">
      <CertificateDialog :certificate-details="certificateDetails"></CertificateDialog>
    </el-dialog>
     <!--IOT详情-->
     <el-dialog :title="$t('bike.name254')" :visible.sync="iotDetailsDialog" v-if="iotDetailsDialog" :close-on-click-modal ="false" :before-close="iotClose" width="1440px">
      <div class="top">
        <div>{{ eBikeBaseInfo.ebikeId }}</div>
      </div>

      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name255') }}</div>
        <el-divider></el-divider>
      </div>

      <el-form label-width="280px" style="width:100%;">
        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name256')">{{ iotDetails.username }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name257')">{{ iotDetails.connected ? '在线' : '离线' }} </el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name258')">{{ iotDetails.port }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name259')">{{ iotDetails.node }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name260')">{{ iotDetails.ip_address }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name261')">{{ iotDetails.keepalive }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name262')">{{ iotDetails.created_at }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name263')">{{ iotDetails.expiry_interval }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name264')">{{ iotDetails.connected_at }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name265')">{{ iotDetails.send_pkt }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name266')">{{ iotDetails.recv_pkt }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name267')">{{ iotDetails.recv_cnt }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name268')">{{ iotDetails.max_awaiting_rel }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name269')">{{ iotDetails.max_inflight }}</el-form-item></el-col>
        </el-row>
      </el-form>
      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name270') }}</div>
        <el-divider></el-divider>
      </div>
      <el-table :data="subscribeList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }">
      <el-table-column label="node" prop="node"  > </el-table-column>
      <el-table-column label="clientid" prop="clientid" ></el-table-column>
      <el-table-column label="qos" prop="qos" ></el-table-column>
      <el-table-column label="topic" prop="topic" ></el-table-column>
    </el-table>
    <div class="title-style">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name271') }}</div>
        <el-divider></el-divider>
      </div>
      <div class='date-picker'>
        <el-date-picker
            v-model="searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
        <el-button type="primary" size="small" @click="getIotLog" class="search-bt" :loading="loading">{{ $t('public.name3') }}</el-button>
      </div>
      <div style="margin:15px;" v-html="iotLogInfo"></div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="modelFormtrue">确定</el-button> -->
        <el-button @click="iotClose">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
       <!--分配归属-->
       <el-dialog :title="$t('bike.name156')" :visible.sync="addIotNumDialog" v-if="addIotNumDialog" :close-on-click-modal ="false" :before-close="closeBelong" width="600px">
      <el-form ref="belongFormRef"  label-width="150px" :rules="belongFormRules"  :model="belong">
        <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="belong.tenantId"  :show-all-levels="false" @change="handleChange1" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions1 }" clearable></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBelong" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBelong">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
      <!--导入车辆出厂信息-->
      <el-dialog :title="$t('bike.name400')" :visible.sync="bikeFactoryUploadDialog" v-if="bikeFactoryUploadDialog" :close-on-click-modal ="false" :before-close="closeBikeUpload" width="600px">
      <el-form label-width="200px">
        <el-form-item :label="$t('bike.name100')">
          <a :href="importFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile6" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--修改车辆出厂信息-->
      <el-dialog :title="$t('bike.name402')" :visible.sync="editEbikeInfoDialog" v-if="editEbikeInfoDialog" :close-on-click-modal ="false" :before-close="closeBikeUpload" width="600px">
      <el-form label-width="200px">
        <el-form-item :label="$t('bike.name100')">
          <a :href="modifyFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange" id="fileInput">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile7" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { tenantList } from '@/api/manage.js'
import { ebikeCertificateConformity, queryWebMaintainRecordListByEbikeCode, querySaleListByEbikeCode, fullEbikeCcc, fullEbikeFactory, findIotStatusInfo, findIotSubscribeTopic, findIotCmdLog, selecteById, tenantBindEbike, importEbikeModelCertificateConformity, downloadTempFile, importEditEbikeInfo } from '@/api/bike.js'
import { downloadExcel } from '@/utils/utils'
import CertificateDialog from '../bikemanage/certificateDialog.vue'
import EBikeDetailsDialog from '../components/eBikeDetailsDialog.vue'
export default {
  data() {
    return {
      importFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv9.xlsx',
      modifyFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv2.xlsx',
      tenantIds: [],
      loading: false,
      certificateDialog: false,
      editEbikeInfoDialog: false,
      queryInfo: {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        ebikeId: '',
        ebikeCode: '',
        ebikeModelId: '',
        searchTime: [],
        startDate: '',
        endDate: '',
        saleStatus: ''
      },
      total: 0,
      buttonPerms: '',
      tenantOptions: [],
      tableList: [],
      srcList: [],
      tableLoading: false,
      dialogVisible: false,
      dialogVisible2: false,
      maintenanceRecordTableList: [],
      tableLoading1: false,
      spanArr: [],
      pos: 0,
      salesRecordTableList: [],
      saleStatusOptions: [
        { label: this.$t('bike.name312'), value: '0' },
        { label: this.$t('bike.name311'), value: '1' }
      ],
      eBikeDetailsDialog: false,
      certificateDetails: {},
      eBikeBaseInfo: {
        ebikeId: '',
        ebikeCode: ''
      },
      type: 4,
      iotDetailsDialog: false,
      iotDetails: {},
      subscribeList: [],
      iotLogInfo: '',
      searchTime: [],
      timer: null,
      addIotNumDialog: false,
      belongFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ]
      },
      belong: {
        tenantId: []
      },
      selectionList: [],
      loading2: false,
      bikeFactoryUploadDialog: false,
      fiveWayCodeFile: null,
      uploadTenantId: '',
      manufacturerOptions: [],
      loading3: false,
      loadingVehicle: false
    }
  },
  components: {
    CertificateDialog,
    EBikeDetailsDialog
  },
  created () {
    const lang = localStorage.getItem('lang')
    if (lang === 'en') {
      this.importFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20the%20vehicle%27s%20factory%20information.xlsx'
      this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Modify%20the%20factory%20information%20of%20the%20vehicle%20.xlsx'
    } else {
      this.importFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv9.xlsx'
      this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv2.xlsx'
    }
    this.buttonPerms = localStorage.getItem('buttonPerms')
    this.getTenantList()
  },
  beforeDestroy() {
    this.$bus.$off('lang')
  },
  mounted() {
    this.$bus.$on('lang', (lang) => {
      if (lang === 'en') {
        this.importFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20the%20vehicle%27s%20factory%20information.xlsx'
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Modify%20the%20factory%20information%20of%20the%20vehicle%20.xlsx'
      } else {
        this.importFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv9.xlsx'
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv2.xlsx'
      }
    })
    this.getPageList()
    this.getTenantList()
  },
  computed: {},
  methods: {
    showDetailsDialog(row) {
      this.eBikeBaseInfo.ebikeId = row.ebikeId
      this.eBikeBaseInfo.ebikeCode = row.ebikeCode
      this.eBikeDetailsDialog = true
    },
    showCertificateDialog(row) {
      selecteById({ id: row.eccId })
        .then(res => {
          this.certificateDetails = res.data || {}
        })
        .catch(res => {
          this.certificateDetails = {}
        })
      this.certificateDialog = true
    },
    showIotDetailsDialog(row) {
      this.iotDetailsDialog = true
      this.eBikeBaseInfo.ebikeId = row.ebikeId
      this.getIOTDetails()
      this.timer = setInterval(this.getIOTDetails, 10000)
    },
    getIOTDetails() {
      findIotStatusInfo({ ebikeId: this.eBikeBaseInfo.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.iotDetails = res.data.iotStatusInfo || {}
          }
        })
        .catch(() => {
        })
      findIotSubscribeTopic({ ebikeId: this.eBikeBaseInfo.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.subscribeList = res.data.topic
          }
        })
        .catch(() => {
          this.subscribeList = []
        })
    },
    getIotLog() {
      if (this.searchTime) {
        this.loading = true
        findIotCmdLog({ startTime: this.searchTime[0], endTime: this.searchTime[1], ebikeId: this.eBikeBaseInfo.ebikeId, wrap: '</br>' }).then((res) => {
          if (res.data.iotLogInfo) {
            this.iotLogInfo = res.data.iotLogInfo
          } else {
            this.iotLogInfo = this.$t('public.name39')
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    iotClose() {
      this.iotDetailsDialog = false
      this.iotDetails = {}
      this.subscribeList = []
      this.iotLogInfo = ''
      this.searchTime = []
      clearInterval(this.timer)
      this.timer = null
    },
    closeEBikeDialog() {
      if (this.$refs.eBikeDetailsDialog) {
        this.$refs.eBikeDetailsDialog.close()
      }
      this.eBikeDetailsDialog = false
      this.eBikeBaseInfo = {
        ebikeId: '',
        ebikeCode: ''
      }
    },
    closeCertificateDialog() {
      this.certificateDialog = false
    },
    showAddIotNum() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.addIotNumDialog = true
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    submitBelong() {
      this.$refs.belongFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('public.name32'), this.$t('public.name23'), {
            confirmButtonText: this.$t('public.name25'),
            cancelButtonText: this.$t('public.name14'),
            type: 'warning'
          })
            .then(() => {
              this.loading2 = true
              const ebikeIdList = []
              this.selectionList.map((item, index) => {
                ebikeIdList.push(item.ebikeId)
              })
              tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.belong.tenantId })
                .then((res) => {
                  console.log('res====', res)
                  this.loading2 = false
                  if (res.code === 200) {
                    this.$refs.table.clearSelection()
                    this.closeBelong()
                    this.getPageList()
                  }
                })
                .catch(() => {
                  this.loading2 = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('public.name33')
              })
            })
        } else {
          return false
        }
      })
    },
    closeBelong() {
      this.addIotNumDialog = false
      this.belong.tenantId = ''
    },
    importBikeFactoryDialog() {
      this.loadOptions2()
      this.bikeFactoryUploadDialog = true
    },
    closeBikeUpload() {
      this.bikeFactoryUploadDialog = false
      this.editEbikeInfoDialog = false
      this.fiveWayCodeFile = null
    },
    loadOptions2() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName
            }))
            this.manufacturerOptions = options
            this.uploadTenantId = this.manufacturerOptions[0].value
          } else {
            this.manufacturerOptions = []
          }
        })
        .catch(() => {})
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
    },
    delFile() {
      this.fiveWayCodeFile = null
    },
    importEditEbikeInfo() {
      this.loadOptions2()
      this.editEbikeInfoDialog = true
    },
    uploadSectionFile6() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeModelCertificateConformity(formData)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name399'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name400'))
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name401'))
            }
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.bikeFactoryUploadDialog = false
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch((res) => {
          this.loading3 = false
        })
    },
    uploadSectionFile7() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEditEbikeInfo(formData)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name460'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name402'))
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name461'))
            }
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.editEbikeInfoDialog = false
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch((res) => {
          this.loading3 = false
        })
    },
    resetQuery() {
      this.queryInfo = {
        pageNumber: 1,
        pageSize: 10,
        tenantId: '',
        ebikeId: '',
        ebikeCode: '',
        searchTime: [],
        startDate: '',
        endDate: '',
        saleStatus: ''
      }
      this.tenantIds = []
      this.getCertificateList()
    },
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      if (this.queryInfo.searchTime) {
        this.queryInfo.startDate = this.queryInfo.searchTime[0]
        this.queryInfo.endDate = this.queryInfo.searchTime[1]
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
      this.getCertificateList()
    },
    getCertificateList() {
      this.tableLoading = true
      if (this.queryInfo.searchTime) {
        this.queryInfo.startDate = this.queryInfo.searchTime[0]
        this.queryInfo.endDate = this.queryInfo.searchTime[1]
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
      ebikeCertificateConformity(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.page.records
          this.total = res.data.page.total
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    loadOptions1(node, resolve) {
      if (node.level === 3) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange1(value) {
      this.belong.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    showMaintenanceRecord(row) {
      this.dialogVisible = true
      this.tableLoading1 = true
      queryWebMaintainRecordListByEbikeCode({ ebikeCode: row.ebikeCode }).then(res => {
        this.tableLoading1 = false
        if (res.code === 200) {
          this.maintenanceRecordTableList = res.data
          this.spanArr = []
          this.pos = 0
          this.getSpanArr(this.maintenanceRecordTableList)
        }
      }).catch(() => {
        this.maintenanceRecordTableList = []
        this.tableLoading1 = false
      })
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].id === data[i - 1].id &&
            data[i].tenantName === data[i - 1].tenantName &&
            data[i].userName === data[i - 1].userName &&
            data[i].createTime === data[i - 1].createTime &&
            data[i].ebikeCode === data[i - 1].ebikeCode &&
            data[i].ebikeId === data[i - 1].ebikeId &&
            data[i].storeAddress === data[i - 1].storeAddress
          ) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 10) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    },
    showSalesRecord(row) {
      this.dialogVisible2 = true
      this.tableLoading1 = true
      querySaleListByEbikeCode({ ebikeCode: row.ebikeCode }).then(res => {
        this.tableLoading1 = false
        if (res.code === 200) {
          this.salesRecordTableList = res.data
        }
      }).catch(() => {
        this.salesRecordTableList = []
        this.tableLoading1 = false
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisible2 = false
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getCertificateList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getCertificateList()
    },
    exportCcc() {
      this.loading = false
      if (this.queryInfo.searchTime) {
        this.queryInfo.startDate = this.queryInfo.searchTime[0]
        this.queryInfo.endDate = this.queryInfo.searchTime[1]
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
      fullEbikeCcc(this.queryInfo).then(res => {
        this.loading = false
        downloadExcel(res, this.$t('bike.name462'))
      }).catch(() => {
        this.loading = false
      })
    },
    exportVehicle() {
      this.loadingVehicle = false
      if (this.queryInfo.searchTime) {
        this.queryInfo.startDate = this.queryInfo.searchTime[0]
        this.queryInfo.endDate = this.queryInfo.searchTime[1]
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
      fullEbikeFactory(this.queryInfo).then(res => {
        this.loadingVehicle = false
        downloadExcel(res, this.$t('bike.name530'))
      }).catch(() => {
        this.loadingVehicle = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.productCertificate-container {
  display: flex;
  flex-direction: column;
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .dialog-title{
    margin-right: 30px;
  }
  .dialog-content{
    width: 100%;
    display: flex;
    flex-direction: column;
    .title{
      font-size: 30px;
      color: #000;
      width: 100%;
      text-align: center;
    }
    .sb-hgzbh{
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .table-content{
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
    }
  }

  .col-view{
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #dcdddd;
    .col1{
      width: 30%;
      border-right: 1px solid #dcdddd;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .col2{
      width: 70%;
      height: 40px;
      display: flex;
      align-items: center;
      .col2-row{
        display: flex;
        flex-direction: row;
        width: 100%;
        .col2-row1{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row2{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row3{
          height: 40px;
          width: 34%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .col-view1{
    width: 100%;
    display: flex;
    flex-direction: row;
    .col1{
      width: 30%;
      border-right: 1px solid #dcdddd;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .col2{
      width: 70%;
      height: 40px;
      display: flex;
      align-items: center;
      .col2-row{
        display: flex;
        flex-direction: row;
        width: 100%;
        .col2-row1{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row2{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row3{
          height: 40px;
          width: 34%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .col-view3{
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #dcdddd;
    .col1{
      width: 54.6%;
      border-right: 1px solid #dcdddd;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .col2{
      width: 45.4%;
      height: 40px;
      display: flex;
      align-items: center;
      .col2-row{
        display: flex;
        flex-direction: row;
        width: 100%;
        .col2-row1{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row2{
          width: 33%;
          border-right: 1px solid #dcdddd;
          height: 40px;
          display: flex;
          align-items: center;
        }
        .col2-row3{
          height: 40px;
          width: 34%;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .row-style1 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    width: 100%;
    display: flex;
    align-items: center;
    // background: #f5f5f5;
  }
  .row-style2 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .row-style3 {
    border: 1px solid #dcdddd;
    border-top: none;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .col-style {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .col-style1 {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
  }

  .col-style2 {
    border-right: 1px solid #dcdddd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;;
  }
  .col-style3 {
    border-right: 1px solid #dcdddd;
    border-bottom: 1px solid #dcdddd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 80px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .center{
    text-align: center;
  }
  .border-right{
    border-right: 1px solid #dcdddd;
  }
  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
}
</style>
